/**
 * The one type treatment for a form field's label.
 *
 * 169: `DateRangePicker` styled its two labels
 * `text-xs text-text-muted uppercase tracking-wide font-semibold` while `HomePage`'s pickup-location
 * label — the field directly above them, in the same card — was `text-xs text-gray-400`. Side by
 * side that read as two different label voices: one uppercase and semibold, one sentence-case and
 * regular weight, in a raw grey rather than the muted-text token.
 *
 * `docs/DESIGN-spotify-app.md` is explicit that uppercase + wide tracking is this product's
 * "systematic label voice" (§ Uppercase buttons as system), and that muted labels are the Silver
 * token — which `text-text-muted` resolves to and `text-gray-400` only approximates. So the
 * picker's treatment was the correct one and the home field was the drift.
 *
 * TYPOGRAPHY ONLY — no margin. Spacing belongs to the layout that owns the field (a `mb-*` on the
 * label in one place, a `gap-*` on the wrapper in another), and baking one in here would
 * double-space every site that already has its own.
 */
export const FIELD_LABEL_CLASS =
  'block text-xs text-text-muted uppercase tracking-wide font-semibold';
